import { render, staticRenderFns } from "./SubscriptionGroups.vue?vue&type=template&id=281e3728&scoped=true"
import script from "./SubscriptionGroups.vue?vue&type=script&lang=js"
export * from "./SubscriptionGroups.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionGroups.vue?vue&type=style&index=0&id=281e3728&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e3728",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('281e3728')) {
      api.createRecord('281e3728', component.options)
    } else {
      api.reload('281e3728', component.options)
    }
    module.hot.accept("./SubscriptionGroups.vue?vue&type=template&id=281e3728&scoped=true", function () {
      api.rerender('281e3728', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TradeWatcher/SubscriptionGroups.vue"
export default component.exports